import { Badge, Button } from 'reactstrap';

function ExpensesFilters({
    currentFilter,
    setCurrentFilter,
    filters,
}: {
    currentFilter: { label: string };
    setCurrentFilter: React.Dispatch<
        React.SetStateAction<{
            label: string;
            value: string;
        }>
    >;
    filters: { label: string; value: string }[];
}) {
    return (
        <div>
            <div
                className='d-flex justify-content-between'
                style={{
                    margin: '0 -40px',
                    padding: '8px 40px',
                    backgroundColor: 'rgba(244, 125, 41, 0.1)',
                    overflowX: 'auto',
                }}
            >
                {filters.map((filter, i) => {
                    return (
                        <Button
                            style={{
                                textTransform: 'none',
                                padding: '10px 10px',
                            }}
                            color={filter === currentFilter ? 'warning' : ''}
                            onClick={() => setCurrentFilter(filter)}
                            className={`${
                                currentFilter === filter
                                    ? 'fw-bolder'
                                    : 'fw-light'
                            }`}
                            key={i}
                        >
                            {filter.label}{' '}
                            <Badge
                                color={`${
                                    filter === currentFilter ? 'dark' : 'none'
                                }`}
                                className={`border border-dark ${
                                    currentFilter !== filter
                                        ? 'text-dark'
                                        : 'text-white'
                                } rounded-circle py-1 px-2`}
                            ></Badge>
                        </Button>
                    );
                })}
            </div>
        </div>
    );
}

export default ExpensesFilters;
